import { AddressDataEligibility, EmailDataEligibility, TelDataEligibility } from '../models';
import { DqePhoneTypeEnum } from '../enums';

const errorCodes = ['02', '04', '91', '92', '93', '94'];
const errorCodesAddress = ['41', '61', '80', '81', '90'];
const warningCodesAddress = ['21', '22', '23', '24', '30', '50', '70'];
const validCodeAddress = ['10', '20', '25'];
const countryAddressStartWithStreetNumber = ['FR'];

export function isPhoneNumberValid(telDataEligibility: TelDataEligibility): boolean {
  const telDataEligibilityFirstValues = Object.values(telDataEligibility)[0];
  switch (telDataEligibilityFirstValues['Type']) {
    case DqePhoneTypeEnum.FIXE:
      return false;
    case DqePhoneTypeEnum.MOBILE:
      return telDataEligibilityFirstValues['IdError'] !== 0;
    case DqePhoneTypeEnum.EMPTY:
      return telDataEligibilityFirstValues['IdError'] > 2;
  }
  return false;
}

export function isEmailValid(emailDataEligibility: EmailDataEligibility): boolean {
  return !errorCodes.includes(Object.values(emailDataEligibility).find((obj) => obj.IdError)?.IdError);
}

export function isAddressValid(codeDetail: string): boolean {
  return !errorCodesAddress.includes(codeDetail);
}

export function isNotSureAddress(codeDetail: string): boolean {
  return warningCodesAddress.includes(codeDetail);
}

export function isAdjustmentAddress(codeModification): boolean {
  const [address, postalCode, city] = codeModification;
  return (address === '1' || postalCode === '1' || city === '1');
}

export function checkCurrentCountryAddressStartWithStreetNumber(country: string): boolean {
  return countryAddressStartWithStreetNumber.includes(country);
}

export function isCodeDetailValid(codeDetail: string): boolean {
  return validCodeAddress.includes(codeDetail);
}

export function isValidEmailFormat(emailInput: string): boolean {
  if (emailInput?.trim().length === 0) {
    return false;
  }
  const emailPattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;
  return emailPattern.test(emailInput.trim());
}

export function getCodeDetailFromAddressData(addressDataEligibility: AddressDataEligibility) {
  return Object.values(addressDataEligibility).find((obj) => obj.DQECodeDetail)?.DQECodeDetail;
}

export function getCodeModificationFromAddressData(addressDataEligibility: AddressDataEligibility) {
  return Object.values(addressDataEligibility).find((obj) => obj.Code_Modification)?.Code_Modification;
}
